import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IDebitAccounts } from '../../shared/models/debitAccounts.model';
import { IPostAutoDebitAccountBody } from '../../shared/models/automaticDebits.model';

@Component({
  selector: 'app-automatic-debit',
  templateUrl: './automatic-debit.component.html',
  styleUrls: ['./automatic-debit.component.css'],
})
export class AutomaticDebitComponent {
  @Output() setAutoDebitAccount =
    new EventEmitter<IPostAutoDebitAccountBody | null>();
  @Output() setAutoDebitAccountImage = new EventEmitter<string>();
  @Output() changeAutomaticDebit = new EventEmitter<boolean>();
  @Input() visbleCancel: boolean = true;
  step: number = 1;
  entitys: IDebitAccounts[] | null = null;
}
